var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/extenders/localization-form.js
var LocalizationForm = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "handleSubmit", (event) => {
      event.preventDefault();
      const newLocale = event.submitter.value;
      this.countryCodeElement.value = newLocale;
      this.languageCodeElement.value = newLocale;
      this.formElement.submit();
    });
    this.localizationFormElement = this;
    this.formElement = this.localizationFormElement.querySelector("form");
    this.countryCodeElement = this.formElement.querySelector('input[name="country_code"]');
    this.languageCodeElement = this.formElement.querySelector('input[name="language_code"]');
    this.formElement.addEventListener("submit", this.handleSubmit, true, { passive: false });
  }
};
if (customElements.get("localization-form") === void 0) {
  customElements.define("localization-form", LocalizationForm);
}
